module.exports = __webpack_public_path__ + "img/antes_despues_152.013bf402.png";